import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const FinalCTA = () => {
  const handleCadastro = () => {
    window.open("https://forms.gle/jiHcGPWw6gXNCiWM8", "_blank");
  };

  return (
    <section 
      className="py-16 md:py-24 relative overflow-hidden"
      style={{
        background: "linear-gradient(135deg, hsl(16 98% 50%), hsl(29 98% 55%))"
      }}
    >
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center text-white">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
            Sua casa merece mais conforto, segurança e beleza.
          </h2>
          
          <p className="text-xl md:text-2xl mb-10 text-white/95">
            Cadastre-se agora e descubra como participar do Minha Casa Mais Bonita!
          </p>

          <Button 
            onClick={handleCadastro}
            size="lg"
            className="bg-white text-[hsl(var(--orange-strong))] hover:bg-white/90 transition-all rounded-full px-10 py-7 text-xl font-bold shadow-2xl hover:scale-105 transform"
          >
            Fazer meu cadastro agora
            <ArrowRight className="ml-2 h-6 w-6" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
